// TelcoTrack - Status Constants
// Polygon status colors (Nezačato / Probíhá / Hotové) and workflow phase colors

import { STATUS_RED, STATUS_YELLOW, STATUS_GREEN } from '../interfaces/object.interface';
import { PHASE_COLORS } from './object-workflow/phase-codes';
import { getPhaseInfoByCode } from './object-workflow/workflow-model';

// Polygon status colors (Czech labels)
export const STATUS_COLORS = {
  [STATUS_RED]: '#dc2626',      // Red
  [STATUS_YELLOW]: '#eab308',   // Yellow
  [STATUS_GREEN]: '#16a34a'     // Green
} as const;

// Normalize status string to polygon status (Czech or English variants)
const POLYGON_STATUS_ALIASES: Record<string, string> = {
  'Nezačato': STATUS_RED,
  'Probíhá': STATUS_YELLOW,
  'Hotové': STATUS_GREEN,
  'NO_INFORMATION': STATUS_RED,
  'IN_PROGRESS': STATUS_YELLOW,
  'COMPLETE': STATUS_GREEN
};

function normalizePolygonStatus(status: string): string {
  return POLYGON_STATUS_ALIASES[status] ?? status;
}

/** Hex barva fáze podle kódu (`WF.PHASE.N`) — prohledá všechny varianty workflow, ne jen výchozí. */
function resolveWorkflowPhaseColor(phaseCode: string): string | null {
  const info = getPhaseInfoByCode(phaseCode);
  if (!info) return null;
  const key = info.phase.colors.general;
  return key ? PHASE_COLORS[key] : PHASE_COLORS.RED;
}

/**
 * Get color for object or polygon status.
 * For objects: uses workflow phase color when available.
 * For polygons or unknown: uses polygon status colors (Nezačato/Probíhá/Hotové).
 */
export function getObjectStatusColor(status: string, _objectType?: string): string {
  const phaseColor = resolveWorkflowPhaseColor(status);
  if (phaseColor) return phaseColor;
  const normalized = normalizePolygonStatus(status);
  return STATUS_COLORS[normalized as keyof typeof STATUS_COLORS] ?? '#6b7280';
}

export const getStatusColor = getObjectStatusColor;
